/** Wallet (Mu Points) endpoints — applicant/recruiter/staffing/admin. */
import client from './client';

function _downloadCsv(res, fallbackName) {
  const cd = res.headers?.['content-disposition'] || res.headers?.['Content-Disposition'] || '';
  const m = cd.match(/filename="?([^";]+)"?/i);
  const filename = m ? m[1] : fallbackName;
  const blob = new Blob([res.data], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return filename;
}

export const walletAPI = {
  me: async () => (await client.get('/wallet/me')).data,
  pricing: async () => (await client.get('/wallet/pricing')).data,
  myTransactions: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, String(v)); });
    return (await client.get(`/wallet/transactions?${q.toString()}`)).data;
  },
  downloadMyCsv: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, String(v)); });
    q.append('format', 'csv');
    const res = await client.get(`/wallet/transactions?${q.toString()}`, { responseType: 'blob' });
    return _downloadCsv(res, 'mu_transactions.csv');
  },
  headTransfer: async (userId, amount, reason = '') =>
    (await client.post('/wallet/head/transfer', { user_id: userId, amount, reason })).data,
  headSubordinates: async () => (await client.get('/wallet/head/subordinates')).data,
  adminListWallets: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, String(v)); });
    return (await client.get(`/wallet/admin/all?${q.toString()}`)).data;
  },
  adminListApplicantWallets: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, String(v)); });
    return (await client.get(`/wallet/admin/applicants?${q.toString()}`)).data;
  },
  adminCredit: async (userId, amount, reason = '') =>
    (await client.post('/wallet/admin/credit', { user_id: userId, amount, reason })).data,
  adminTransactions: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, String(v)); });
    return (await client.get(`/wallet/admin/transactions?${q.toString()}`)).data;
  },
  adminDownloadCsv: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, String(v)); });
    q.append('format', 'csv');
    const res = await client.get(`/wallet/admin/transactions?${q.toString()}`, { responseType: 'blob' });
    return _downloadCsv(res, 'admin_mu_transactions.csv');
  },
  adminGetPricing: async (orgId) => (await client.get(`/wallet/admin/pricing/${orgId}`)).data,
  adminSetPricing: async (orgId, pricing) => (await client.put(`/wallet/admin/pricing/${orgId}`, { pricing })).data,
};

export default walletAPI;
